const {PC_RACE_VERDAN} = require('./../../pcRaceIdList')

const Verdan_img = require('./../../../images/races/verdan.jpg')

module.exports = {
  [PC_RACE_VERDAN]: Verdan_img,
}
